import api from './api'

export interface ScoutQuery {
  id: number
  user_id: number
  query_text: string
  min_subscribers: number
  business_context: string | null
  target_keywords: string | null
  is_active: boolean
  schedule_hours: number
  search_types: string
  last_run_at: string | null
  created_at: string
  pending_count: number
}

export interface ScoutQueryCreate {
  query_text: string
  min_subscribers?: number
  business_context?: string
  target_keywords?: string[]
  schedule_hours?: number
  search_types?: string
}

export interface ScoutQueryUpdate {
  query_text?: string
  min_subscribers?: number
  business_context?: string
  target_keywords?: string[]
  schedule_hours?: number
  is_active?: boolean
  search_types?: string
}

export interface ScoutCandidate {
  id: number
  user_id: number
  scout_query_id: number
  telegram_id: number
  username: string | null
  title: string
  channel_type: string | null
  members_count: number | null
  description: string | null
  linked_chat_id: number | null
  has_comments: boolean
  relevance_score: number
  ai_reason: string | null
  ai_topics: string | null
  status: string
  discovered_at: string
  reviewed_at: string | null
}

export interface ScoutCandidateStats {
  total: number
  pending: number
  approved: number
  dismissed: number
  blacklisted: number
}

export const scoutService = {
  // Queries
  async getQueries(): Promise<ScoutQuery[]> {
    const res = await api.get<ScoutQuery[]>('/scout/queries')
    return res.data
  },

  async createQuery(data: ScoutQueryCreate): Promise<ScoutQuery> {
    const res = await api.post<ScoutQuery>('/scout/queries', data)
    return res.data
  },

  async updateQuery(id: number, data: ScoutQueryUpdate): Promise<ScoutQuery> {
    const res = await api.patch<ScoutQuery>(`/scout/queries/${id}`, data)
    return res.data
  },

  async deleteQuery(id: number): Promise<void> {
    await api.delete(`/scout/queries/${id}`)
  },

  async runQueryNow(id: number): Promise<{ message: string }> {
    const res = await api.post<{ message: string }>(`/scout/queries/${id}/run`)
    return res.data
  },

  // Candidates
  async getCandidates(params?: {
    status?: string
    query_id?: number
    min_score?: number
  }): Promise<ScoutCandidate[]> {
    const res = await api.get<ScoutCandidate[]>('/scout/candidates', { params })
    return res.data
  },

  async getCandidateStats(): Promise<ScoutCandidateStats> {
    const res = await api.get<ScoutCandidateStats>('/scout/candidates/stats')
    return res.data
  },

  async approveCandidate(id: number): Promise<void> {
    await api.post(`/scout/candidates/${id}/approve`)
  },

  async dismissCandidate(id: number): Promise<void> {
    await api.post(`/scout/candidates/${id}/dismiss`)
  },

  async blacklistCandidate(id: number): Promise<void> {
    await api.post(`/scout/candidates/${id}/blacklist`)
  },

  async bulkAction(candidateIds: number[], action: string): Promise<{ processed: number }> {
    const res = await api.post<{ processed: number }>('/scout/candidates/bulk-action', {
      candidate_ids: candidateIds,
      action,
    })
    return res.data
  },
}
